import axios from 'axios';
import store from '../store'

const api = axios.create({
    baseURL: process.env.VUE_APP_URL_API_COMUNICADOS
});

const getAuthHeaders = token => ({
    Authorization: `Bearer ${token}`,
});

export default {
    async getNotificaciones() {
        try {
            const response = await api.get('clients/compania/notificaciones/sin-leer', {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async marcarNotificacionLeida(id) {
        try {
            const response = await api.get(`clients/compania/notificaciones/marcar-como-leida/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async marcarNotificacionLeidaMasiva() {
        try {
            const response = await api.get('clients/compania/notificaciones/marcar-todas-como-leidas', {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}